<template>
  <div class="wrapper">
    <v-head></v-head>
    <router-view></router-view>
    <v-bottom></v-bottom>
  </div>
</template>

<script>
import vHead from "./Header.vue";
import vBottom from "./Bottom.vue";
export default {
  data() {
    return {
      tagsList: [],
      collapse: false,
    };
  },
  components: {
    vHead,
    vBottom,
  },
  created() {},
};
</script>
<style lang="scss">
body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
@media (min-width: 1200px) {
  .content {
    width: 1200px;
  }
}
@media (min-width: 768px) and (max-width: 1199px) {
  .content {
    width: 100%;
  }
}
@media (max-width: 767px) {
  .content {
    width: 100%;
  }
}
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: rgba(240, 240, 240, 1);
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.5);
  border-radius: 10px;
  background-color: rgba(240, 240, 240, 0.5);
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.5);
  background-color: #cccccc;
}
.gradient-row {
  background: #e0e6f0;
  padding-top: 70px;
  min-height: 900px;
}
a:link {
  color: #477dfd;
  text-decoration: none;
}
a:visited {
  color: #477dfd;
  text-decoration: none;
}
a:hover {
  color: #477dfd;
  text-decoration: none;
}
a:active {
  color: #477dfd;
}
</style>
